export default __webpack_public_path__ + "static/media/excavation6.295a0d5a.jpg";